module.exports = __webpack_public_path__ + "static/media/ALL TRIAL-if-correct-after-10-sec.70859a35.mp3";